import actionTypes from './actionTypes'
import config from '../../../config/config'
import { checkLoggedIn } from '../../../routes/Login/actions'
import { getExpiresIn } from '../../../lib'

const {
  REQUEST_USERDATA,
  RECEIVE_USERDATA,
  REQUEST_TOKENVALIDITY,
  RECEIVE_TOKENVALIDITY,
  USER_VALIDITY,
  SERVER_ERROR_OCURED,
  LOG_OUT,
  SHOULD_REDIRECT,
  SHOULD_REDIRECT_LOGIN,
  SEMINAR_UPGRADE_MODAL,
  TOGGLE_SIDEBAR,
  UPDATE_VIEW,
  TOGGLE_FV_DOMAIN_SIDEBAR
} = actionTypes

export function updateView(height, width) {
  return {
    type: UPDATE_VIEW,
    view: {
      height, width
    }
  }
}

export function toggleSideBar(value) {
  return {
    type: TOGGLE_SIDEBAR,
    value
  }
}

export function toggleFvDomainSideBar(value) {
  return {
    type: TOGGLE_FV_DOMAIN_SIDEBAR,
    value
  }
}

export function receiveUserdata(user) {
  return {
    type: RECEIVE_USERDATA,
    user
  }
}

export function newSeminarUpgradeModal(bool) {
  return {
    type: SEMINAR_UPGRADE_MODAL,
    open: bool
  }
}

export function logoutRequestResult(bool) {
  return {
    type: LOG_OUT,
    logoutSuccess: bool
  }
}

export function shouldRedirectUser(bool) {
  return {
    type: SHOULD_REDIRECT,
    shouldRedirect: bool
  }
}

export function shouldRedirectUserToLogin(bool) {
  return {
    type: SHOULD_REDIRECT_LOGIN,
    redirectToLogin: bool
  }
}

function hasErrored(bool) {
  return {
    type: SERVER_ERROR_OCURED,
    hasErrored: bool
  }
}

export function setUserValidity(bool) {
  return {
    type: USER_VALIDITY,
    userExists: bool
  }
}

function fetchData(token){
  return fetch(`${config.URI}/api/v1/current_user`, {
    headers: {
      'Authenticity-Token': token,
      'Content-Type': 'application/json'
    }
  })
    .then(res => {
      if (!res.ok) {
        throw Error(res.statusText)
      } else {
        return res.json()
      }
    })
}

export function returnUserIfUserExists(token) {
  return function (dispatch) {
    dispatch({type: REQUEST_USERDATA})
    return fetchData(token)
      .then(res => {
        if (res.status && res.status === 'success') {
          let current_user = res.data.current_user
          let parent = res.data.parent
          getExpiresIn(parent).then(function(response){
            current_user['expires_in'] = response;
            dispatch(receiveUserdata(current_user))
          })
        } else if (res.errors) {
          console.error('token not valid')
        }
      })
      .catch((error) => {
        dispatch(hasErrored(true))
      })
  }
}

export function checkValidity(token) {
  return function (dispatch) {
    dispatch({type: REQUEST_USERDATA})
    dispatch({type: REQUEST_TOKENVALIDITY})
    return fetchData(token)
      .then(res => {
        dispatch({type: RECEIVE_TOKENVALIDITY})
        return res
      })
  }
}

export function checkTokenOnPathChange(token) {
  return function (dispatch) {
    return fetchData(token)
      .then(res => {
        return res
      })
  }
}

export function logoutUser(token) {
  return function (dispatch) {
    dispatch({type: REQUEST_USERDATA})
    return fetch(`${config.URI}/api/v1/logout`, {
      method: 'DELETE',
      headers: {
        'Authenticity-Token': token,
        'Content-Type': 'application/json'
      }
    })
      .then(res => {
        if (!res.ok) {
          throw Error(res.statusText)
        } else {
          return res.json()
        }
      })
      .then(res => {
        if (res.status && res.status === 'success') {
          dispatch(shouldRedirectUserToLogin(true))
          dispatch(shouldRedirectUser(false))
          dispatch(logoutRequestResult(true))
          dispatch(checkLoggedIn(false))
        } else {
          dispatch(shouldRedirectUser(true))
          dispatch(shouldRedirectUserToLogin(false))
          dispatch(checkLoggedIn(true))
        }
      })
      .catch((error) => {
        dispatch(hasErrored(true))
      })
  }
}



// WEBPACK FOOTER //
// src/layouts/LoggedIn/actions/index.js